import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import BetslipNotificationsImpl from './betslip-notifications.js';

/**
 * Displays notifications based on {@link Mojito.Services.Betslip.types.ERROR_CODE|error types}.
 *
 * @class BetslipNotifications
 * @name view
 * @memberof Mojito.Modules.BetslipNotifications
 */

/**
 * BetslipNotifications prop types.
 *
 * @property {Array<Mojito.Services.Betslip.types.Error>} errors - List of errors to be displayed.
 *
 * @memberof Mojito.Modules.BetslipNotifications.view
 */
const propTypes = {
    errors: PropTypes.array.isRequired,
};

export default MojitoCore.Presentation.UIView(
    'BetslipNotifications',
    BetslipNotificationsImpl,
    propTypes
);
